import React from 'react';
import { forgotPassword } from '@/api';
import Button from '@/components/shared/Button';
import Input from '@/components/shared/Input';
import { Form, Formik, getIn } from 'formik';
import getAxiosErrors from '@/utils/getAxiosErrors';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import logo from '@/img/propsavvy-logo-with-text.svg';
import './ForgotPasswordPage.scss';

const baseClass = 'forgotPasswordPage';

interface IValues {
  email: '';
  errorMessage?: string[];
}

const initialValues: IValues = {
  email: '',
  errorMessage: [],
};

const validationSchema = Yup.object().shape({
  email: Yup.string().required('Email is required').email(),
});

const ForgotPasswordPage = () => {
  return (
    <div className={baseClass}>
      <div className={`${baseClass}-view`}>
        <div className={`${baseClass}-view-logo`}>
          <img src={logo} alt="logo" />
          <p className={`${baseClass}-view-logo-desc`}>
            Please enter your E-mail.
          </p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={({ email }, { setSubmitting, setErrors, setStatus }) => {
            forgotPassword({ email })
              .then((res) => {
                if (res.status === 200) {
                  setStatus({ success: 'Email sent' });
                }
              })
              .catch((err) => {
                setErrors(getAxiosErrors(err));
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
            status,
          }) => (
            <Form className={`${baseClass}-view-form`}>
              {status?.success && (
                <>
                  <div className={`${baseClass}-view-form-group-success`}>
                    {status.success}
                  </div>
                  <div className={`${baseClass}-view-form-group-bottom`}>
                    <Link
                      to={`/login`}
                      className={`${baseClass}-view-form-group-bottom-create`}
                    >
                      Sign in
                    </Link>
                  </div>
                </>
              )}
              {!status && (
                <>
                  <div className={`${baseClass}-view-form-group`}>
                    <Input
                      floatLabel
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      name="email"
                      type="text"
                      label="Email"
                      errors={
                        getIn(errors, 'email') && getIn(touched, 'email')
                          ? getIn(errors, 'email')
                          : ''
                      }
                    />
                  </div>
                  <div className={`${baseClass}-view-form-group-submit`}>
                    <Button
                      type={'submit'}
                      className={`${baseClass}-view-form-group-submit-btn`}
                      isDisabled={isSubmitting}
                      isLoading={isSubmitting}
                    >
                      Reset Password
                    </Button>
                    <div className={`${baseClass}--error`}>
                      {errors.errorMessage}
                    </div>
                  </div>
                  <div className={`${baseClass}-view-form-group-bottom`}>
                    <Link
                      to={`/register`}
                      className={`${baseClass}-view-form-group-bottom-create`}
                    >
                      Create an account
                    </Link>
                    <Link
                      to={'/login'}
                      className={`${baseClass}-view-form-group-bottom-forgot`}
                    >
                      Sign in
                    </Link>
                  </div>
                </>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
